export const ValidTool = {

  created() { },
  data() {
    return {
      RESETFORM: "",
    };
  },
  methods: {
    /**
     * 删除  & 批量删除
     * @param {string} url => 'url/'
     * @param {string} ids 要删除的 ids 字符串
     * @param {string} message 删除成功的 提示语  默认  删除成功
     * @param {function} callback 成功后的 回调函数
     */

    async Delete({ url, ids, message = "" }) {
      if (!ids) {
        this.$message.warning("请选择一项在删除");
        return false;
      }
      const res = await this.http.delete(url + ids);
      if (res.code === 0) {
        this.$message.success(message || "删除成功");
      }
      return res;
    },

    DeleteObject(object) {
      let obj = {}
      let arr = Object.entries(object);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][1]) {

          obj[arr[i][0]] = arr[i][1];
        }
      }
      return obj
    },
    /**
     * get 请求参数处理 获取列表
     *
     * @param {object} pam get 请求参数
     *
     */
    async GetPam(pam) {
      let obj = {
        page: 1,
        page_size: 10,

      };
      obj = Object.assign({}, obj, pam);
      return { params: obj };
    },

    /**
     *  elementui 校验地址插件
     * @param {*} rule
     * @param {*} value
     * @param {*} callback
     */
    CheckAddress(rule, value, callback, form) {
      // console.log(rule, value);
      if (
        form.address.area.value === "区" ||
        form.address.city.value === "市" ||
        form.address.province.value === "省"
      ) {
        callback(new Error("请选择省市区域"));
      } else if (!value) {
        callback(new Error("请填写地址详情"));
      } else {
        callback();
      }
    },
    /**
     *
     * @param {object} value 要重置的单位
     * @param {Boolean} type  false 重置  true 获取
     */
    ResetForm({ value, type = false, name = "" }) {
      if (type) {
        if (name) {
          setTimeout(() => {
            this.$refs[name]?.clearValidate();
          }, 0);
        }
        return JSON.parse(this.RESETFORM);
      } else {
        this.RESETFORM = JSON.stringify(value);
      }
    },

    /**
     * 重置搜索参数
     * @param {array[]} list
     */
    ResetSearch(list = []) {
      for (let i = 0; i < list.length; i++) {
        this[list[i]] = "";
      }
    },
    /**
     * 生成下拉选择参数
     * @param {*} obj 
     */
    GetOptions(obj) {
      return new Promise(resolve => {
        let result = []
        Object.entries(obj).forEach(el => {
          result.push({
            id: el[0],
            label: el[1]
          })
        })
        resolve(result)
      })
    }
  },
};
